import { PROJECT_MODES } from "../../constants"
import InteractiveMap from "../InteractiveMap/InteractiveMap"
import Placebo from "../Placebo/Placebo"

const MapBody = ({
	anonymousUserId, 
	researchId, 
	projectMode, 
	isEditMode,
	showReuploadControls,
	showResizeControls,
	setHasUploadedMap,
	onExport
}) => {
	const getDisplayComponent = () => {
		return projectMode === PROJECT_MODES.INTERACTIVE_MAPS_MODE ? 
			<InteractiveMap 
				anonymousUserId={anonymousUserId} 
				researchId={researchId}
				isEditMode={isEditMode}
				showReuploadControls={showReuploadControls}
				showResizeControls={showResizeControls}
				projectMode={projectMode}
				setHasUploadedMap={setHasUploadedMap}
				onExport={onExport}
			/> 
			: 
			<Placebo />
	}

	return (
		<center style={{
			maxWidth: "100vw",
			height: "calc(100vh - 144px)",  // Subtract navbar (64px) and bottom row (80px) heights
			overflow: "hidden",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			padding: "20px"
		}}>
			{getDisplayComponent()}
		</center>
	)
}

export default MapBody